// extracted by mini-css-extract-plugin
export default {"InspectionData":"styles_InspectionData__N2G42","InspectionData__box":"styles_InspectionData__box__NKESe","InspectionData__button":"styles_InspectionData__button__qwffl"};